import templateStr from 'text!./templates/scheduled-coverages.html';
import Schedule from '../models/schedules/Schedule';
import _ from 'underscore';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            model: '=gwPcScheduledCoverages',
            onChange: '=',
            loading: '=',
            readonly: '<',
            flavor: '@'
        },
        link: function link(scope) {
            scope.$watch('flavor', function (f) {
                scope._flavor = f || 'default';
            });
            scope.$watch('model', function () {
                scope.schedules = _.map(scope.model, function (aSchedule) {
                    return new Schedule(aSchedule, scope.onChange);
                });
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/ScheduleCoverages.js
// module id = 794
// module chunks = 0